<!-- 添加计费方案 -->
<template>
    <div class="container containerBox">
        <el-tabs v-model="activeName">
            <el-tab-pane label="计费设置" name="charge">
                <cmp-charge
                    :form="schemeInfo"
                    @onSave="onSaveCharge">
                </cmp-charge>
            </el-tab-pane>
            <el-tab-pane label="价格设置" name="price">
                <cmp-price 
                    :form="schemeInfo"
                    @onSave="onSavePrice"
                    ></cmp-price>
            </el-tab-pane>
            <el-tab-pane label="欠费设置" name="arrearage">
                <cmp-arrearage 
                    :form="schemeInfo"
                    @onSave="onSaveArrearage">
                </cmp-arrearage>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import CmpCharge from '@/components/CmpChargeScheme/CmpCharge'
import CmpArrearage from '@/components/CmpChargeScheme/CmpArrearage'
import CmpPrice from '@/components/CmpChargeScheme/CmpPrice'
import Service from '@/api/Service'
export default {
    name: 'addchargescheme',
    data () {
        return {
            schemeId: '',
            schemeInfo: {},
            activeName: 'charge'
        };
    },
    components: {
        CmpCharge,
        CmpArrearage,
        CmpPrice
    },
    created() {
        this.schemeId = this.$route.params.schemeId;
        this.getData(this.schemeId);
    },

    methods: {
        // 获取计费方案明细
        async getData(oid) {
            let data = await Service.getChargeSchemeInfo({OID : oid});
            if(data) {
                this.schemeInfo = data[0];
            }
        },
        // 保存计费设置
        async onSaveCharge(params) {
            let data = await Service.editScheme_charge(params);
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose:() =>{
                        this.activeName = 'price';
                        this.getData(this.schemeId);
                    }
                });
            }
        },
        // 保存价格设置
        async onSavePrice(params) {
            let data = await Service.editScheme_price(params);
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose:() =>{
                        this.activeName = 'arrearage';
                        this.getData(this.schemeId);
                    }
                });
            }
        },
        // 保存欠费设置
        async onSaveArrearage(params) {
            let data = await Service.editScheme_arrearage(params);
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose:() =>{
                        this.activeName = 'charge';
                        this.getData(this.schemeId);
                        this.$router.push('/chargeschemelist')
                    }
                });
            }
        }
    }
}

</script>
<style lang='css' scoped>
</style>